import { isDesktopApp } from '../utils/environment';
import type { GeneralCache } from './Cache';
import { BrowserCache } from './cache.web.browser';
import { DesktopCache } from './cache.web.desktop';

export const Cache: GeneralCache = isDesktopApp ? DesktopCache : BrowserCache;
